import axios from "axios";
import ReLogin from "../../api/relogin";
import {resetAuthToken, setAuthToken} from "../../utils/auth";
import {AUTH_TENANT, AUTH_USER, localStorageGetJSON, localStorageSet} from "../../localStorage";

export const AUTH_COOKIE = 'x-access-token-my';

export const state = {
  user: localStorageGetJSON(AUTH_USER),
  tenant: localStorageGetJSON(AUTH_TENANT),
};

export const mutations = {
  SET_USER(state, user) {
    state.user = user;
    localStorageSet(AUTH_USER, user);
  },
  SET_TENANT(state, tenant) {
    state.tenant = tenant;
    localStorageSet(AUTH_TENANT, tenant);
  },
};

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.user;
  },
  user(state) {
    if (typeof state.user === 'string') {
      return JSON.parse(state.user);
    }
    return state.user;
  },
  tenant(state) {
    if (typeof state.tenant === 'string') {
      return JSON.parse(state.tenant);
    }
    return state.tenant;
  },
};

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({state, dispatch}) {
    dispatch('validate');
  },

  async token({commit, dispatch}, token) {
    setAuthToken(token);
    window.localStorage.setItem(AUTH_COOKIE, token);
    return await dispatch('validate').then(u => u);
  },

  // Logs in the current user.
  async logIn({commit, dispatch, getters}, {email, password} = {}) {
    if (getters.loggedIn) return dispatch('validate');

    const token = await axios.post(`/auth/api/v1/login`, {email, password}).then(({data: {success: {token}}}) => token);

    passwordEncrypt(email, password);
    setAuthToken(token);
    process.browser && window.localStorage.setItem(AUTH_COOKIE, token);

    return await dispatch('validate').then(u => u);
  },

  // Logs out the current user.
  logOut({commit}) {
    // eslint-disable-next-line no-unused-vars
    commit('SET_USER', null);
    commit('SET_TENANT', null);
    resetAuthToken();
    window.localStorage.removeItem(AUTH_COOKIE);
    window.localStorage.removeItem(AUTH_COOKIE + '-relogin');
    return true;
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  // eslint-disable-next-line no-unused-vars
  async validate({commit, state}) {
    try {
      if (!window.localStorage.getItem(AUTH_COOKIE)) return false;

      const [user, tenant] = await Promise.all([
        axios.get(`/entities/api/v1/users/-/profile`).then(({data}) => (commit('SET_USER', data), data)),
        axios.get(`/entities/api/v1/tenants/-/profile`).then(({data}) => (commit('SET_TENANT', data), data)),
      ]);
      return user;
    } catch (e) {
      return false;
    }
  },
};

// ===
// Private helpers
// ===

const passwordEncrypt = (email, password) => new ReLogin().encrypt({email, password});
